'use client'

import { Button } from '@paladise/ui/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@paladise/ui/components/ui/dialog'
import { cn } from '@paladise/ui/lib/utils'
import { useTranslations } from 'next-intl'
import { useTransition } from 'react'
import { isEmbed } from 'store/server-context/static'

interface Prop {
  isOpen: boolean
  onOpenChange: (v: boolean) => void
  onOk?: () => Promise<void>
  onCancel?: () => void
}

const DowngradeModal = ({ isOpen, onOpenChange, onCancel, onOk }: Prop) => {
  const [loading, startTransition] = useTransition()
  const t = useTranslations()
  return (
    <Dialog
      open={isOpen}
      onOpenChange={v => {
        onOpenChange(v)
        !v && onCancel?.()
      }}
    >
      <DialogContent
        position={isEmbed ? 'bottom' : 'center'}
        className={cn(
          'min768:min-w-[580px] px-4 pt-4',
          isEmbed ? 'w-full' : 'w-[80%]',
        )}
      >
        <img src="/images/alert.svg" alt="alert" className="mx-auto size-16" />
        <DialogTitle className="text-title text-label-l1 mb-3 mt-6">
          {t('downgrade_title')}
        </DialogTitle>
        <ul className="text-body text-label-l2 mb-7 list-disc space-y-3 pl-5">
          <li>{t('downgrade_desc')}</li>
          <li>{t('downgrade_desc2')}</li>
        </ul>

        <div className="min768:flex-row flex flex-col-reverse">
          <Button
            variant="text"
            className="text-label-l2 !text-callout min768:m-2 w-full"
            loading={loading}
            disabled={loading}
            onClick={() => {
              onOpenChange(false)
              onCancel?.()
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            variant="primary"
            className="!text-callout min768:m-2 w-full rounded-full"
            loading={loading}
            disabled={loading}
            onClick={() => {
              if (loading) return
              startTransition(async () => {
                await onOk?.()
              })
            }}
          >
            {t('ok')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DowngradeModal
